export enum GadgetSortFields {
    NAME = "name",
    LAST_MODIFIED_ON = "latestPublishedVersion.lastModifiedOn"
} 
export interface GadgetSortColumns {
    field: GadgetSortFields;
    order: string;
    label: string;
}
export const GadgetSortInitialValue = [
    {
        field: GadgetSortFields.LAST_MODIFIED_ON,
        order: "DESC",
        label: "Last Published"
    },
    {
        field: GadgetSortFields.NAME,
        order: "ASC",
        label: "Alphabetical"
    }
];

export const getGadgetSortFieldsByLabel = (label: String): GadgetSortColumns | undefined => {
    return Object.values(GadgetSortInitialValue).find(column => column.label === label);
}